module.exports = __webpack_public_path__ + "static/media/Logo_Mont-Tremblant_Couleur.03a1ecc0.jpg";